export default {"src":"/_next/static/image/public/images/flags/flag_41.03661622c94dcce28b3c4572932ec1bb.svg","height":16,"width":24};